import { IconButton, Stack } from "@mui/material";
import React, { useCallback } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useReactFlow } from "reactflow";
const NodeEdit = ({ onEdit, onDelete, id }) => {
  const { setNodes, setEdges } = useReactFlow();
  const onNodeDelete = useCallback(() => {
    setNodes((nds) => nds.filter((node) => node.id !== id));
    setEdges((eds) =>
      eds.filter((edge) => edge.source !== id && edge.target !== id)
    );
  }, []);
  const onNodeEdit = useCallback(() => {
    setNodes((nds) =>
      nds.map((item) =>
        item.id === id
          ? { ...item, data: { ...item.data, edit: true } }
          : { ...item, data: { ...item.data, edit: false } }
      )
    );
  }, []);

  return (
    <Stack
      direction={"row"}
      spacing={1}
      sx={{ position: "absolute", top: -32, right: -8 }}
    >
      <IconButton
        sx={{
          backgroundColor: "rgba(25, 118, 210, 0.08)", // blue background
          color: "#1976d2", // blue icon
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.25)",
          },
        }}
        onClick={onNodeEdit}
        size="small"
        aria-label="edit"
      >
        <EditIcon fontSize="small" />
      </IconButton>

      {/* Delete Button */}
      <IconButton
        sx={{
          backgroundColor: "rgba(229, 57, 53, 0.08)", // red background
          color: "#d32f2f", // red icon
          "&:hover": {
            backgroundColor: "rgba(229, 57, 53, 0.25)",
          },
        }}
        onClick={onNodeDelete}
        size="small"
        aria-label="delete"
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};

export default NodeEdit;
